import { Flag } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface LogoProps {
  /** `full` shows the wordmark, `mark` is the square only. */
  variant?: 'full' | 'mark';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const MARK_SIZE = {
  sm: 'size-7 rounded-sm',
  md: 'size-8 rounded-md',
  lg: 'size-11 rounded-md',
} as const;

const ICON_SIZE = {
  sm: 'size-4',
  md: 'size-[18px]',
  lg: 'size-6',
} as const;

const WORD_SIZE = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-3xl',
} as const;

export function Logo({ variant = 'full', size = 'md', className }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span
        aria-hidden="true"
        className={cn(
          'relative flex shrink-0 items-center justify-center overflow-hidden bg-primary text-on-primary',
          MARK_SIZE[size],
        )}
      >
        <span className="kerb absolute inset-0" />
        <Flag className={cn('relative', ICON_SIZE[size])} strokeWidth={2.5} />
      </span>

      {variant === 'full' ? (
        <span className={cn('font-display font-extrabold uppercase leading-none tracking-wide', WORD_SIZE[size])}>
          <span className="text-text">MychronoHelper</span>
          <span className="ml-1 text-primary">Kart</span>
        </span>
      ) : null}
    </span>
  );
}
